import type { FunctionDefinition, FunctionPortDefinition, Node, NodeInstance } from '@glueapp/graph-types';
export function makeExampleNodeInstance(node: Node): NodeInstance {
    return {
        id: 1,
        nodeId: node.id,
        inPorts: node.inPorts,
        outPorts: node.outPorts,
        selected: false,
        portValues: {},
        portUserDefinedTypes: {},
        position: {
            x: 0,
            y: 0,
        },
        state: {},
    };
}

export function makeFunctionExampleNodeInstance(node: Node, functionDef: FunctionDefinition): NodeInstance {
    return {
        id: 1,
        nodeId: node.id,
        inPorts: functionDef.inputPortDefinitions.map((port: FunctionPortDefinition) => ({
            name: port.name,
            type: port.type,
            optional: port.optional,
        })),
        outPorts: functionDef.outputPortDefinitions.map((port: FunctionPortDefinition) => ({
            name: port.name,
            type: port.type,
            optional: port.optional,
        })),
        selected: false,
        portValues: {},
        portUserDefinedTypes: {},
        position: {
            x: 0,
            y: 0,
        },
        state: { functionName: functionDef.name },
        functionId: functionDef.id,
    };
}
